module.exports = __webpack_public_path__ + "static/06-87b02b6c7bd20610ddadca1c03709b47.png";